import { Link } from "react-router-dom";
import { site } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20warm%20abstract%20artistic%20background%20of%20glowing%20spotlights%20and%20flowing%20amber%20coral%20smoke%20shapes%20over%20deep%20terracotta%20darkness%2C%20cinematic%20editorial%20texture%2C%20rich%20contrast%2C%20no%20people%2C%20no%20text%2C%20elegant%20and%20mysterious&width=1600&height=900&seq=hero-guatan-01&orientation=landscape"
          alt="诱惑吃瓜 首页背景 — 暖调聚光灯与流动烟雾构成的艺术画面"
          title="诱惑吃瓜 围观现场"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/45 to-foreground-950/75"></div>

      <div className="relative w-full px-4 md:px-10 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-3xl animate-fadeUp">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-100 text-xs md:text-sm backdrop-blur-sm">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulseSoft"></span>
            实时更新中 · 现在有 {site.stats[0].value} 人一起围观
          </span>

          <h1 className="mt-6 font-hand text-5xl md:text-7xl text-background-50 leading-tight">
            {site.name}
          </h1>
          <p className="mt-4 text-lg md:text-2xl text-accent-200 font-medium">{site.slogan}</p>
          <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed max-w-xl">
            {site.tagline}。这里聚集了最会吃瓜的一群人，最新进展第一时间同步，热点反转帮你理好时间线，让你不错过任何精彩后续。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/chat"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-chat-smile-2-line w-5 h-5 flex items-center justify-center"></i>
              进聊天室蹲后续
            </Link>
            <Link
              to="/hot"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-fire-line w-5 h-5 flex items-center justify-center"></i>
              逛逛热瓜榜
            </Link>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5 max-w-4xl">
          {site.stats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm px-4 py-4"
            >
              <i className={`${item.icon} text-accent-300 text-xl w-6 h-6 flex items-center justify-center`}></i>
              <p className="mt-2 text-xl md:text-2xl font-bold text-background-50">{item.value}</p>
              <p className="mt-1 text-xs text-background-200">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}